import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import AdminGuard from "@/components/auth/admin-guard";
import SuperLayout from "@/components/layout/super-layout/super-layout";
import { PermissionsProvider } from "@/components/context/permissions-provider";
import { SidebarProvider } from "@/components/context/sidebar-context";
import { CommandMenuProvider } from "@/components/context/command-menu-context";
import CommandMenu from "@/components/global-search/command-menu";
import VersionCheck from "@/components/layout/version-check";
import { isDesktopApp } from "@/lib/edition/is-desktop";
import { isLocalInstallEdition } from "@/lib/edition/edition";

export const Route = createFileRoute("/_super")({
  component: SuperAdminLayout,
  beforeLoad: () => {
    if (isDesktopApp() || isLocalInstallEdition()) {
      throw redirect({ to: "/auth/sign-in" });
    }
  },
});

function SuperAdminLayout() {
  return (
    <AdminGuard requireSuperAdmin={true}>
      <PermissionsProvider>
        <CommandMenuProvider>
          <SidebarProvider>
            <SuperLayout>
              <Outlet />
              <VersionCheck />
            </SuperLayout>
            <CommandMenu />
          </SidebarProvider>
        </CommandMenuProvider>
      </PermissionsProvider>
    </AdminGuard>
  );
}
